module.exports = __webpack_public_path__ + "static/media/ssl-animacao.0c58b132.mp4";